module.exports = __webpack_public_path__ + "img/01.b96f2d08.png";